import { render, staticRenderFns } from "./Loan-Waiver-Policy-Settings.vue?vue&type=template&id=f2c91926&scoped=true&"
import script from "./Loan-Waiver-Policy-Settings.vue?vue&type=script&lang=js&"
export * from "./Loan-Waiver-Policy-Settings.vue?vue&type=script&lang=js&"
import style0 from "./Loan-Waiver-Policy-Settings.vue?vue&type=style&index=0&id=f2c91926&scoped=true&lang=css&"
import style1 from "./Loan-Waiver-Policy-Settings.vue?vue&type=style&index=1&id=f2c91926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c91926",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDataTable,VDialog,VEditDialog,VFlex,VIcon,VLayout,VSnackbar,VSwitch,VTextField})
